export default __webpack_public_path__ + "static/media/ordinace.da195c0d.jpg";